import type { AnySchema, StringSchema } from "yup";
import type { IMisc } from "./interfaces";

export enum InputType {
  BoolSelect = "boolselect",
  TimeSelect = "timeselect",
  TextAreaInput = "textareainput",
  SelectDropdown = "selectdropdown",
  SelectQuery = "selectquery",
  SelectTable = "table",
  RadioSelect = "radioselect",
  EnumSelect = "enumselect",
  NumberInput = "numberinput",
  DecimalInput = "decimalinput",
  IntegerInput = "integerinput",
  PercentageInput = "percentageinput",
  CurrencyInput = "currencyinput",
  RichText = "richtext",
  FileUpload = "fileupload",
  DateSelect = "dateselect",
  DateTimeSelect = "datetimeselect",
  InputText = "inputtext",
  MultiSelect = "readonly",
  PickList = "picklist",
  DateRange = "daterange",
  Info = "info",
  YearSelect = "yearselect",
  MonthSelect = "monthselect",
  ContractSummary = "contractsummary",
}

interface IColSpans {
  sm: number;
  md: number;
  lg: number;
  xl: number;
  xxl: number;
}

export interface IGenericField {
  value?: any;
  label?: string;
  validation?: AnySchema;
  errors?: string[] | undefined;
  misc?: IMisc;
  inputType?: InputType;
  placeholder?: string;
  change?: Function;
  disabled?: boolean;
  hide?: boolean;
  colspan?: IColSpans;
  [field: string]: any;
}

export interface IGenericForm {
  [field: string]: IGenericField;
}

export enum FilterMatchMode {
  STARTS_WITH = "startsWith",
  CONTAINS = "contains",
  NOT_CONTAINS = "notContains",
  ENDS_WITH = "endsWith",
  EQUALS = "equals",
  NOT_EQUALS = "notEquals",
  IN = "in",
  LESS_THAN = "lessThan",
  LESS_THAN_OR_EQUAL_TO = "lessThanOrEqualTo",
  GREATER_THAN = "greaterThan",
  GREATER_THAN_OR_EQUAL_TO = "greaterThanOrEqualTo",
  BETWEEN = "between",
  DATE_IS = "dateIs",
  DATE_IS_NOT = "dateIsNot",
  DATE_BEFORE = "dateBefore",
  DATE_AFTER = "dateAfter",
}
